import angular from 'angular';
import documentsListComponent from './documents-list.component';
import documentsListService from './documents-list.service';
import documentsListConfig from './documents-list.config';

let documentsListModule = angular.module('app.documentsList',[])
  .component('documentsList', documentsListComponent)
  .service('documentsListService', documentsListService)
  .config(documentsListConfig);

export default documentsListModule;






/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/documents-list/documents-list.js
 **/